import { Tag } from './components';

export default Tag;
